import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_IOS_MOBILE, IS_MOBILE_BROWSER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

export const multiTariffMobileInitTabAndroid = getFeature('multi-tariff-mobile-init-tab-android') || 'advanced';
export const multiTariffMobileInitTabIos = getFeature('multi-tariff-mobile-init-tab') || 'advanced';
export const multiTariffMobileInitTab = IS_IOS_MOBILE ? multiTariffMobileInitTabIos : multiTariffMobileInitTabAndroid;

const multiTariffTouch: false | 'a' | 'b' | 'c' = IS_MOBILE_BROWSER && getFeature('multi-tariff-touch-show');
const multiTariffWebviewIOS: false | 'a' | 'b' | 'c' = IS_WEBVIEW && getFeature('multi-tariff-ios-show');
const multiTariffWebviewAndroid: false | 'a' | 'b' | 'c' = IS_WEBVIEW && getFeature('multi-tariff-android-show');
const multiTariffWebview = IS_IOS_MOBILE ? multiTariffWebviewIOS : multiTariffWebviewAndroid;
export const multiTariffMobile = IS_WEBVIEW ? multiTariffWebview : multiTariffTouch;

/* CLOUDWEB-19477 [Webview And/iOS] Доработки по мультитарифу на вебвью */
const multiTariffWebviewHighlightIOS: boolean = IS_WEBVIEW && isFeature('multi-tariff-ios-highlight');
const multiTariffWebviewHighlightAndroid: boolean = IS_WEBVIEW && isFeature('multi-tariff-android-highlight');
export const multiTariffHighlightWebview: boolean = IS_IOS_MOBILE ? multiTariffWebviewHighlightIOS : multiTariffWebviewHighlightAndroid;

/* CLOUDWEB-19477 [Webview And/iOS] Вертикальные тарифы в мультитарифе */
const multiTariffWebviewVerticalIOS: boolean = IS_WEBVIEW && isFeature('multi-tariff-ios-vertical');
const multiTariffWebviewVerticalAndroid: boolean = IS_WEBVIEW && isFeature('multi-tariff-android-vertical');
export const multiTariffVerticalWebview: boolean = IS_IOS_MOBILE ? multiTariffWebviewVerticalIOS : multiTariffWebviewVerticalAndroid;

// Это для дебага
const BasicTariffsDefaultValue = {
    year: [
        'W1TB_1y_june_promotion_ms_force_tiral', // Акционный - надо будет поменять когда кончится акция
        'W64GB_1y_blackfriday_2023_discount_single_quota_cloud',
        'W128GB_1y_lc_blackfriday_2023_discount_single_quota_cloud',
        'W256GB_1y_blackfriday_2023_discount_single_quota_cloud',
        'W512GB_1y_blackfriday_2023_discount_single_quota_cloud',
        'W2TB_1y_blackfriday_2023_discount_single_quota_cloud',
        'W4TB_1y_blackfriday_2023_discount_single_quota_cloud',
    ],
    month: [
        'W1T1m_single_quota_2022_cloud',
        'W64G1m_single_quota_2022_cloud',
        'W128G1m_single_quota_2022_cloud',
        'W256G1m_single_quota_2022_cloud',
        'W512G1m_single_quota_2022_cloud',
        'W2T1m_single_quota_2022_cloud',
        'W4T1m_single_quota_2022_cloud',
    ],
};

// Тарифы минимальные для тача.
const multiTariffBasicTariffListTouch = getFeature('multi-tariff-basic-tariff-list-touch') || BasicTariffsDefaultValue;
// Тарифы минимальные для iOS
const multiTariffBasicTariffListIOS = getFeature('multi-tariff-basic-tariff-list-ios') || BasicTariffsDefaultValue;
// Тарифы минимальные для Android
const multiTariffBasicTariffListAndorid = getFeature('multi-tariff-basic-tariff-list-android') || BasicTariffsDefaultValue;
const multiTariffBasicTariffListWebview = IS_IOS_MOBILE ? multiTariffBasicTariffListIOS : multiTariffBasicTariffListAndorid;
export const multiTariffBasicTariffListMobile = IS_WEBVIEW ? multiTariffBasicTariffListWebview : multiTariffBasicTariffListTouch;

const AdvancedTariffsDefaultValue = {
    year: [
        'W1TB_1y_landing_segmentation_discount',
        'W256GB_1y_landing_segmentation_discount',
        'W512GB_1y_landing_segmentation_discount',
        'W2TB_1y_landing_segmentation_discount',
        'W4TB_1y_landing_segmentation_discount',
    ],
    month: [
        'W1TB_1m_landing_segmentation_main',
        'W256GB_1m_landing_segmentation_main',
        'W512GB_1m_landing_segmentation_main',
        'W2TB_1m_landing_segmentation_main',
        'W4TB_1m_landing_segmentation_main',
    ],
};

// Тарифы основные для тача.
const multiTariffAdvancedTariffListTouch = getFeature('multi-tariff-advanced-tariff-list-touch') || AdvancedTariffsDefaultValue;
// Тарифы основные для iOS
const multiTariffAdvancedTariffListIOS = getFeature('multi-tariff-advanced-tariff-list-ios') || AdvancedTariffsDefaultValue;
// Тарифы минимальные для Android
const multiTariffAdvancedTariffListAndorid = getFeature('multi-tariff-advanced-tariff-list-android') || AdvancedTariffsDefaultValue;
const multiTariffAdvancedTariffListWebview = IS_IOS_MOBILE ? multiTariffAdvancedTariffListIOS : multiTariffAdvancedTariffListAndorid;
export const multiTariffAdvancedTariffListMobile = IS_WEBVIEW ? multiTariffAdvancedTariffListWebview : multiTariffAdvancedTariffListTouch;

// !!!!! Незнаю надо ли семейные тарифы разделять на платформы
// Если надо будет - раздели плз на платформы как выше.
const FamilyTariffsDefault = {
    year: ['W1TB_1y_family_features_a'],
    month: ['W1TB_1m_family_features_mobile_a'],
};

export const multiTariffFamilyTariffListMobile = getFeature('multi-tariff-family-tariff-list-mobile') || FamilyTariffsDefault;

if (IS_MOBILE_BROWSER || IS_WEBVIEW) {
    registerExperiment('multitariff-mobile', multiTariffMobile, [
        AnalyticEventNames.MOBILE_LANDING_SHOWN,
        AnalyticEventNames.QUOTA_LANDING_SHOWN,
        AnalyticEventNames.MULTITARIFF_TYPE_CLICK_M,
        AnalyticEventNames.MULTITARIFF_SIZE_CLICK_M,
        AnalyticEventNames.TARIFF_CLICK,
    ]);
}
